function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { dataLayer, Datalayer } from '@finect/front-gtm';
import { Inner, HeaderContent, BottomContent, Button, Title, Subtitle, SecondaryCTA } from './partials';
export var Jumbo = function (_React$Component) {
  _inherits(Jumbo, _React$Component);
  var _super = _createSuper(Jumbo);
  function Jumbo() {
    var _this;
    _classCallCheck(this, Jumbo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onDataLayer", function (withCallBack) {
      var _this$props = _this.props,
        id = _this$props.id,
        link = _this$props.link,
        variant = _this$props.variant;
      dataLayer({
        id: 'Jumbo',
        type: 'click',
        params: {
          id: "jumbo-".concat(id || link || 'not-set'),
          link: link,
          variant: variant
        },
        callback: function callback() {
          if (withCallBack) window.location.href = _this.props.link;
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      if (_this.props.mainOnClick) {
        _this.props.mainOnClick();
        _this.onDataLayer(false);
        return;
      }
      _this.onDataLayer(true);
    });
    return _this;
  }
  _createClass(Jumbo, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        title = _this$props2.title,
        subtitle = _this$props2.subtitle,
        cta = _this$props2.cta,
        ctaPosition = _this$props2.ctaPosition,
        ctaVariant = _this$props2.ctaVariant,
        contentPosition = _this$props2.contentPosition,
        variant = _this$props2.variant,
        bordered = _this$props2.bordered,
        logoJumbo = _this$props2.logoJumbo,
        id = _this$props2.id,
        link = _this$props2.link;
      return React.createElement(Inner, {
        variant: variant,
        bordered: bordered,
        height: this.props.height,
        coverImage: this.props.coverImage,
        coverImagePhone: this.props.coverImagePhone,
        coverImagePosition: this.props.coverImagePosition,
        backgroundColor: this.props.backgroundColor
      }, React.createElement(Datalayer, {
        id: "Jumbo",
        type: "impressions",
        params: {
          models: [{
            id: "jumbo-".concat(id || link || 'not-set'),
            link: link,
            variant: variant
          }]
        }
      }), React.createElement(HeaderContent, {
        variant: variant,
        color: this.props.color,
        position: contentPosition
      }, logoJumbo ? React.createElement("img", {
        src: logoJumbo,
        alt: title
      }) : null, React.createElement(Title, {
        variant: variant,
        noMargin: !logoJumbo,
        titleFontWeight: this.props.titleFontWeight,
        titleWidth: this.props.titleWidth
      }, title), subtitle ? React.createElement(Subtitle, null, subtitle) : null), React.createElement(BottomContent, {
        variant: variant
      }, this.props.secondaryLinkText ? React.createElement(SecondaryCTA, {
        onClick: this.props.secondaryOnClick,
        href: this.props.secondaryLink
      }, this.props.secondaryLinkText) : null, React.createElement(Button, {
        withRightAnimatedIcon: this.props.ctaWithRightIcon,
        variant: "large",
        width: "auto",
        secondary: ctaVariant === 'secondary',
        yellow: ctaVariant === 'yellow',
        position: ctaPosition !== 'default' ? ctaPosition : contentPosition,
        onClick: this.handleClick
      }, cta, this.props.ctaWithRightIcon && React.createElement(ArrowRight, null))));
    }
  }]);
  return Jumbo;
}(React.Component);
_defineProperty(Jumbo, "defaultProps", {
  variant: 'large',
  ctaVariant: 'primary',
  color: '#000000',
  ctaPosition: 'default',
  ctaWithRightIcon: true,
  contentPosition: 'left'
});